import axios from "axios";
import Config from "../../config";

const v1_actionUrlToBuffer = url => {    
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/global/url-to-buffer?url=${url}`,
        responseType: 'arraybuffer'
    });
};

export default v1_actionUrlToBuffer;
